
import { applyModule, applyModules } from "./modules/utils"
//import { VimeoPlayer } from "./modules/vimeo-player"
import { Carousel } from "./modules/carousel"
import { GsapWrapper } from "./modules/gsap-wrapper"
// import { Confetti } from "./modules/confetti"

import { LottiePlayer } from "./modules/lottie-player"
import lottieBuildBig from "./../assets/lottie/building-big.json"
import lottieDoingGood from "./../assets/lottie/doing-good.json"
import lottieFutureLeaders from "./../assets/lottie/future-leaders.json"
import lottieClaimingMetals from "./../assets/lottie/claiming-metals.json"



declare var jQuery

//applyModule ('.video',          VimeoPlayer, 'https://vimeo.com/40413733')
applyModules('.swiper', Carousel)
applyModules('.gsap-container', GsapWrapper)
// applyModule ('.confetti', Confetti)

applyModule('.lottie-future-leaders', LottiePlayer, lottieFutureLeaders)
applyModule('.lottie-doing-good', LottiePlayer, lottieDoingGood)
applyModule('.lottie-build-big', LottiePlayer, lottieBuildBig)
applyModule('.lottie-claiming-metals', LottiePlayer, lottieClaimingMetals)

;(function($){

  $('html').removeClass('no-js')

})(jQuery)